import appIcon from "../otherImg/hbrlitenewicon.png";

const ChildSafetyPolicy = () => {
    return ( 
        <div className="child-safety-policy">
            <img src={appIcon} alt="" style={{width:"5em", height:"5em", objectFit:"cover"}}/>
            <h2>Standards Against Child Sexual Abuse and Exploitation - CSAE</h2>

            <dl>
                <dt>Our Commitment</dt>
                <dd>We are committed to maintaining a safe and secure environment for all users, especially children. We strictly prohibit any form of child sexual abuse and exploitation - CSAE and actively work to prevent, detect, and report such content or behavior.
                </dd> <br/><br/>

                <dt>Zero-Tolerance Policy</dt>
                <dd>We do not allow:<br/>
                - Any content that depicts, promotes, or facilitates CSAE.<br/>
                - Grooming, solicitation, or inappropriate interactions with minors.<br/>
                - Sharing, storing, or transmitting Child Sexual Abuse Material - CSAM.<br/>
                - Use of our platform for child trafficking or exploitation.<br/>
                </dd> <br/><br/>

                <dt>Detection & Moderation</dt>
                <dd>We implement:<br/>
                - Automated scanning and manual moderation to detect and remove harmful content.<br/>
                - Behavioral monitoring to flag suspicious activity.<br/>
                - Regular audits to ensure compliance with child safety standards.<br/>
                </dd> <br/><br/>

                <dt>User Reporting Tools</dt>
                <dd>Users can report suspected CSAE content directly within the app. Reports are prioritized and reviewed by our safety team, with swift action taken.
                </dd> <br/><br/>

                <dt>Compliance with Laws</dt>
                <dd>We comply with all relevant child protection laws, including: <br/>
                - COPPA (U.S.)<br/>
                - GDPR for children (EU)<br/>
                - Online Safety Act (UK)<br/>
                - Local laws in our operating regions<br/>
                </dd> <br/><br/>

                <dt>Child Safety Contact</dt>
                <dd>
                    For urgent concerns, please contact our Child Safety Officer at: https://horemowbookreaderlite.web.app/contact
                </dd> <br/><br/>
            </dl>
            <h4>Hormeow book reader app | 2025</h4>
        </div>
     );
}
export default ChildSafetyPolicy;